<div (click)="codeInput.focus()" class="code-container">

  <div #fakeContainer class="code-fake-container">
    <!--    <ng-container *ngFor="let item of [].constructor(codeLength); let i = index">-->
    <div #fakeCodeContainer class="code-input-container"></div>
    <div class="code-input-container"></div>
    <div class="code-input-container"></div>
    <div class="code-input-container"></div>
    <!--    </ng-container>-->
  </div>

  <input #codeInput
         (input)="updateSpace()"
         [(ngModel)]="code"
         [attr.maxlength]="codeLength"
         [style.letter-spacing]="space + 'px'"
         [style.right1]="-space + 'px'"
         class="code-input"
         oninput="this.value=this.value.replace(/[^0-9]/g,'')"
         type="tel">
</div>
